
function imageVideoAd({
  adsSelected,
  currentAdIndexes,
  preview,
  handleClicks,
  selectedAd,
  slot1,
  slot2,
}) {
  return (
    // <div>
    //   <div
    //     className={`flex flex-col cursor-pointer pointer-events-auto ${
    //       preview ? "border-2 border-blue-600" : ""
    //     } w-[50px] gap-[10px] sm:w-[100px] sm:gap-[50px]`}
    //   >
    //     {/* Image Ad */}
    //     <img
    //       src={img}
    //       alt={adsSelected[slot1]?.[currentAdIndexes[slot1]]?.ids}
    //       data-id={`ad-${slot1}`}
    //       onClick={(e) =>
    //         handleClicks(e, adsSelected[slot1]?.[currentAdIndexes[slot1]])
    //       }
    //       className={`w-full h-[150px] sm:h-[220px] object-fill cursor-pointer transition ${
    //         selectedAd === `ad-${slot1}`
    //           ? "border-2 border-red-500 shadow-lg animate-pulse"
    //           : "shadow-sm"
    //       }`}
    //     />

    //     {/* Video Ad */}
    //     <video
    //       autoPlay
    //       muted
    //       loop
    //       playsInline
    //       data-id={`ad-${slot2}`}
    //       onClick={(e) =>
    //         handleClicks(e, adsSelected[slot2]?.[currentAdIndexes[slot2]])
    //       }
    //       className={`w-full h-[150px] sm:h-[220px] object-fill cursor-pointer transition ${
    //         selectedAd === `ad-${slot2}`
    //           ? "border-2 border-red-500 shadow-lg animate-pulse"
    //           : "shadow-sm"
    //       }`}
    //     >
    //       <source src={vid} type="video/mp4" />
    //     </video>
    //   </div>
    // </div>

    <div>
      {(adsSelected[slot1]?.[currentAdIndexes[slot1]]?.iterations > 0 ||
        adsSelected[slot2]?.[currentAdIndexes[slot2]]?.iterations > 0 ||
        preview) && (
        <div
          className={`flex flex-col cursor-pointer pointer-events-auto ${
            preview ? "border-2 border-blue-600" : ""
          } w-[50px] gap-[10px] sm:w-[100px] sm:gap-[50px]`}
        >
          {(adsSelected[slot1] ||
            (!adsSelected[slot1] && preview === "image")) && (
            <img
              src={adsSelected[slot1]?.[currentAdIndexes[slot1]]?.image}
              alt={adsSelected[slot1]?.[currentAdIndexes[slot1]]?.ids}
              data-id={`ad-${slot1}`}
              onClick={(e) =>
                handleClicks(e, adsSelected[slot1]?.[currentAdIndexes[slot1]])
              }
              className={`w-full h-[150px] sm:h-[220px] object-fill cursor-pointer transition ${
                selectedAd === `ad-${slot1}`
                  ? "border-2 border-red-500 shadow-lg animate-pulse"
                  : "shadow-sm"
              }`}
            />
          )}
          {(adsSelected[slot2] ||
            (!adsSelected[slot2] && preview === "video")) && (
            <video
              autoPlay
              muted
              loop
              playsInline
              data-id={`ad-${slot2}`}
              className={`w-full h-[150px] sm:h-[220px] object-fill cursor-pointer transition ${
                selectedAd === `ad-${slot2}`
                  ? "border-2 border-red-500 shadow-lg animate-pulse"
                  : "shadow-sm"
              }`}
              onClick={(e) =>
                handleClicks(e, adsSelected[slot2]?.[currentAdIndexes[slot2]])
              }
            >
              <source
                src={adsSelected[slot2]?.[currentAdIndexes[slot2]]?.video}
                type="video/mp4"
              />
            </video>
          )}
        </div>
      )}
    </div>
  );
}

export default imageVideoAd;

